export default __webpack_public_path__ + "static/media/landing_team.d38dde51.png";